import '../ViewNFT.css'
import { useEffect, useState } from "react"
import Loading from "../../../components/Loading";

function NFTCommunity(){
    return (
        <div>
            <p>Nothing here yet</p>
        </div>
    )
}

export default NFTCommunity;